import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Family } from 'src/app/model/family';
import { AppelsService } from '../../service/appels.service';
import { Observable, map, tap } from 'rxjs';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DeliberationDto } from 'src/app/model/dto/deliberationDto';
import { TestBed } from '@angular/core/testing';
import { th } from 'date-fns/locale';
import { Router } from '@angular/router';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { LogsDeliberation } from 'src/app/model/LogsDeliberation';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-deliberation',
  templateUrl: './deliberation.component.html',
  styleUrls: ['./deliberation.component.css'],
})
export class DeliberationComponent implements OnInit, AfterViewInit {
  listParam!: Family[];

  paramForm!: FormGroup;

  showSpinner = false;

  showModal = false;
  cohorte: any = null;

  // Repartition des candidatures
  dataByCategorie!: any;
  femaleBycategoryIA: number = 0;
  maleBycategoryIA: number = 0;
  femaleBycategoryDEV: number = 0;
  maleBycategoryDEV: number = 0;
  femaleBycategoryEB: number = 0;
  maleBycategoryEB: number = 0;
  femaleBycategoryTECYB: number = 0;
  maleBycategoryTECYB: number = 0;
  femaleBycategoryCCA: number = 0;
  maleBycategoryCCA: number = 0;
  totalHom: number = 0;
  totalFem: number = 0;
  totalCandidat: number = 0;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private appelsService: AppelsService,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerServiceService,
    private router: Router,
    private utilisateurService: UtilisateursService
  ) {
    this.paramForm = this.formBuilder.group({});

    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit(): void {
    this.spinnerService.showSpinner();
    this.cohorte = sessionStorage.getItem('cohorte');
    this.utilisateurService
      .getCandidatureStatistics(this.cohorte)
      .pipe()
      .subscribe({
        next: (stats) => {
          //console.log('statsss',stats)

          this.totalCandidat = stats.candidatureNumber;
          this.totalHom = stats.maleNumber;
          this.totalFem = stats.femaleNumber;

          stats.familyStatsList.forEach((family) => {
            if (family.familyName === 'INTELLIGENCE ARTIFICIELLE & DONNÉES') {
              this.femaleBycategoryIA = family.femaleNumber;
              this.maleBycategoryIA = family.maleNumber;
            }

            if (family.familyName === 'DÉVELOPPEMENT LOGICIEL') {
              this.femaleBycategoryDEV = family.femaleNumber;
              this.maleBycategoryDEV = family.maleNumber;
            }

            if (family.familyName === 'E-BUSINESS') {
              this.femaleBycategoryEB = family.femaleNumber;
              this.maleBycategoryEB = family.maleNumber;
            }
            if (
              family.familyName ===
              'TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE'
            ) {
              this.femaleBycategoryTECYB = family.femaleNumber;
              this.maleBycategoryTECYB = family.maleNumber;
            }
            if (
              family.familyName === 'CRÉATION DE CONTENU AUDIOVISUELS ANIMES'
            ) {
              this.femaleBycategoryCCA = family.femaleNumber;
              this.maleBycategoryCCA = family.maleNumber;
            }
          });

          this.spinnerService.hideSpinner();
        },
        error: (err: any) => {
          alert('Erreur de Recuperation des Données');
        },
      });

    this.appelsService
      .getDefaultParam()
      .pipe()
      .subscribe({
        next: (reponse) => {
          this.listParam = reponse;

          //console.log('liste :',this.listParam)
          this.listParam.forEach((param) => {
            this.paramForm.addControl(
              'Quota_' + param.id,
              this.formBuilder.control(
                param.donneesFamily[0].quota,
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C1_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c1 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C2_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c2 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C3_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c3 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C4_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c4 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C5_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c5 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
            this.paramForm.addControl(
              'C6_' + param.id,
              new FormControl(
                {
                  value: Math.floor(
                    (param.donneesFamily[0].partCategories[0].c6 *
                      param.donneesFamily[0].quota) /
                      100
                  ),
                  disabled: true,
                },
                Validators.required
              )
            );
          });
          this.spinnerService.hideSpinner();
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });

    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
      {
        label: 'REPARTITION DES CANDIDATURES',
        url: `/dashboard/appels/deliberation/${this.cohorte}`,
      },
    ];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.listParam.forEach((param) => {
        this.paramForm
          .get('Quota_' + param.id)
          ?.valueChanges.subscribe((values) => {
            this.paramForm
              .get('C1_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c1 * values) / 100
                )
              );
            this.paramForm
              .get('C2_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c2 * values) / 100
                )
              );
            this.paramForm
              .get('C3_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c3 * values) / 100
                )
              );
            this.paramForm
              .get('C4_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c4 * values) / 100
                )
              );
            this.paramForm
              .get('C5_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c5 * values) / 100
                )
              );
            this.paramForm
              .get('C6_' + param.id)
              ?.setValue(
                Math.floor(
                  (param.donneesFamily[0].partCategories[0].c6 * values) / 100
                )
              );
          });
      });
    }, 3000);
  }

  onSubmit(): void {
    this.showModal = false;

    window.scrollTo(0, 0);

    this.spinnerService.showSpinner();

    const formaValue = this.paramForm.value;
    let deliberationData: DeliberationDto[] = [];

    let Q_IAD: number = 0;
    let Q_DLog: number = 0;
    let Q_eBus: number = 0;
    let Q_TCys: number = 0;

    //console.log(formaValue);

    //console.log(this.listParam);

    this.listParam.forEach((param) => {
      const nom = param.name;
      const quota = formaValue['Quota_' + param.id];
      const listQuota = [
        param.donneesFamily[0].partCategories[0].c1,
        param.donneesFamily[0].partCategories[0].c2,
        param.donneesFamily[0].partCategories[0].c3,
        param.donneesFamily[0].partCategories[0].c4,
        param.donneesFamily[0].partCategories[0].c5,
        param.donneesFamily[0].partCategories[0].c6,
      ];

      switch (nom) {
        case 'INTELLIGENCE ARTIFICIELLE & DONNÉES':
          Q_IAD = quota;
          break;
        case 'DÉVELOPPEMENT LOGICIEL':
          Q_DLog = quota;
          break;
        case 'E-BUSINESS':
          Q_eBus = quota;
          break;
        case 'TECHNOLOGIES EMERGENTES ET SÉCURITÉ NUMÉRIQUE':
          Q_TCys = quota;
          break;
        case 'CRÉATION DE CONTENU AUDIOVISUELS ANIMES':
          Q_TCys = quota;
          break;
        default:
          //// //console.log("Not Found")
          break;
      }

      /*  const deliberation = new DeliberationDto(nom,{tC:listQuota,N:quota})
      deliberationData.push(deliberation) */
    });

    const logsDeliberation = new LogsDeliberation(
      Q_IAD,
      Q_TCys,
      Q_eBus,
      Q_DLog
    );

    // console.log(logsDeliberation);

    setTimeout(() => {
      this.appelsService
        .executeDeliberation(logsDeliberation)
        .pipe()
        .subscribe({
          next: (data) => {
            if (data) {
              this.spinnerService.hideSpinner();

              setTimeout(() => {
                sessionStorage.setItem('fromdelib', '1');

                this.router.navigate([
                  '/dashboard/appels/admis/' + this.cohorte,
                ]);
              });
            }
          },
          error: (err) => {
            alert('Erreur de Recuperation des Données');
          },
        });
    }, 5000);
  }

  onReset(): void {
    this.listParam.forEach((param) => {
      this.paramForm.get('Quota_' + param.id)?.setValue(0);
      this.paramForm.get('C1_' + param.id)?.setValue(0);
      this.paramForm.get('C2_' + param.id)?.setValue(0);
      this.paramForm.get('C3_' + param.id)?.setValue(0);
      this.paramForm.get('C4_' + param.id)?.setValue(0);
      this.paramForm.get('C5_' + param.id)?.setValue(0);
      this.paramForm.get('C6_' + param.id)?.setValue(0);
    });
  }

  onRefresh(): void {
    this.listParam.forEach((param) => {
      this.paramForm
        .get('Quota_' + param.id)
        ?.setValue(param.donneesFamily[0].quota);

      this.paramForm
        .get('C1_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c1 *
              param.donneesFamily[0].quota) /
              100
          )
        );
      this.paramForm
        .get('C2_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c2 *
              param.donneesFamily[0].quota) /
              100
          )
        );
      this.paramForm
        .get('C3_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c3 *
              param.donneesFamily[0].quota) /
              100
          )
        );
      this.paramForm
        .get('C4_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c4 *
              param.donneesFamily[0].quota) /
              100
          )
        );
      this.paramForm
        .get('C5_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c5 *
              param.donneesFamily[0].quota) /
              100
          )
        );
      this.paramForm
        .get('C6_' + param.id)
        ?.setValue(
          Math.floor(
            (param.donneesFamily[0].partCategories[0].c6 *
              param.donneesFamily[0].quota) /
              100
          )
        );
    });
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }
}
